// DataLayer contract: https://github.com/runwayhealth/operations-hub/blob/main/docs/data-layer-contract.md

export enum ProductEntryPoint {
  INITIAL = "initial",
  ADDON = "add-on",
}

// A line is a "product" (an Rx or OTC item) or a "service" (the consultation visit fee).
// These are the values the data layer carries (see Ga4DTO).
export enum ItemCategory {
  PRODUCT = "product",
  SERVICE = "service",
}

export type Currency = "USD" | "EUR";

export enum Currencies {
  USD = "USD",
  EUR = "EUR",
}

// `name` and `id` are internal (cart merging, PostHog-free). They are not emitted.
export type Item = {
  name: string;
  id: string;
  price: number;
  category: ItemCategory;
  productEntryPoint: ProductEntryPoint;
  currency: Currency;
};

export interface Ga4Object {
  currency?: string;
  value?: number;
  addonValue?: number;
  coupon?: string | null;
  transactionId?: string;
  items?: Item[];
  method?: string;
}

export enum GA4Events {
  PURCHASE = "purchase",
  BEGIN_CHECKOUT = "begin_checkout",
  START_CONSULTATION = "start_consultation",
  ADD_SHIPPING_INFO = "add_shipping_info",
  ADD_PAYMENT_INFO = "add_payment_info",
  LOGIN = "login",
  SIGN_UP = "sign_up",
  ADD_TO_CART = "add_to_cart",
  REMOVE_FROM_CART = "remove_from_cart",
  GENERATE_LEAD = "generate_lead",
  VIEW_ITEM = "view_item", // TODO - implement this event
  VIEW_ITEM_LIST = "view_item_list", // TODO - implement this event
}
